// scroller
import scroller from '../v1/v1Scroller';

// setting
const setGoogleMap = function(option) { // eslint-disable-line
  const _this = this; // eslint-disable-line

  if (!option) return;

  if (!option.mapFeature) return;
  _this.feature = option.mapFeature;

  if (!option.mapOption) return;
  _this.mapOption = option.mapOption;

  _this.iconBase = option.iconBase || '';
  _this.noteText = option.noteText || '';
  _this.mapAppText = option.mapAppText || '';
  _this.bounds = option.bounds || '';
};

setGoogleMap.prototype.init = function() { // eslint-disable-line
  const _this = this; // eslint-disable-line

  try {
    // カレント履歴 infoWindowを閉じたときのフォーカス操作で使う
    _this.strage = null;

    // Create map
    _this.map = _this.addMAp(_this.mapOption);

    // Create markers & InfoWindow
    Array.prototype.forEach.call(_this.feature, (item, index) => {
      const marker = _this.addMarker(item, _this.map);

      const infowindow = new google.maps.InfoWindow({ // eslint-disable-line
        content: _this.getInfoContent(item.name, item.map, _this.noteText, _this.mapAppText),
      });

      // クリックで開く
      marker.addListener('click', function() { // eslint-disable-line
        _this.changeCurrent(index);
      });

      // 閉じたらカレントを解除
      infowindow.addListener('closeclick', function(instance, eventName, handler) { // eslint-disable-line
        _this.changeCurrent(null);
      });

      item.marker = marker; // eslint-disable-line
      item.infowindow = infowindow; // eslint-disable-line
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('Failed to get google');
  }
};

/**
 * 選択変更
 * @param {Number} 配列内の自分の番号
 * @param {String} イベント 'keyboard' だとフォーカス操作を行う
 */
setGoogleMap.prototype.changeCurrent = function(current, event) { // eslint-disable-line
  const _this = this; // eslint-disable-line
  Array.prototype.forEach.call(_this.feature, (item, index) => {
    if (index !== current) {
      // その他を閉じる
      item.infowindow.close();
      item.marker.setZIndex(index);
      item.listDom.setAttribute('aria-selected', false);
    } else {
      // カレントを開く
      item.infowindow.open(item.marker.get('map'), item.marker);
      if (event === 'keyboard') {
        // infoWindowの DOMを取得してフォーカスを移動させる
        const { content } = item.infowindow.gm_bindings_; // eslint-disable-line
        const key = Object.keys(content)[0];
        const keyChild = Object.keys(content[key])[0];
        const destination = content[key][keyChild].content.querySelector('a');
        if (destination)
          setTimeout(() => {
            destination.focus();
          }, 100);
      }
      item.marker.setZIndex(999);
      item.listDom.setAttribute('aria-selected', true);
    }
  });
  // リストが下に来るレイアウトの場合は選択したら地図までスクロール
  if (window.innerWidth < 1024) scroller.toElement(_this.mapOption.target);
  // 閉じたときフォーカスを一覧で最後に選択していた要素へ移動
  if (current === null && _this.strage !== null) {
    const { listDom } = _this.feature[_this.strage];
    setTimeout(() => {
      listDom.focus();
    }, 100);
  }
  // カレント履歴更新
  _this.strage = current;

  // 中心点を設定
  _this.setCenter();
};

/**
 * GoogleMap
 * @param {Object} 表示エリア、スタイル
 * @return {google.maps.Map} インスタンス化された地図
 */
setGoogleMap.prototype.addMAp = function(option) { // eslint-disable-line
  return new google.maps.Map(option.target, { // eslint-disable-line
    center: { lat: 0, lng: 0 },
    zoom: 9,
    // 地図航空写真切替なし
    mapTypeControl: false,
    // ズームの位置
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.LEFT_BOTTOM, // eslint-disable-line
    },
    // ストリートビューの位置
    streetViewControl: true,
    streetViewControlOptions: {
      position: google.maps.ControlPosition.LEFT_BOTTOM, // eslint-disable-line
    },
    // あしらい
    styles: option.style || [],
  });
};

/**
 * GoogleMapへマーカーを建てる
 * @param {Object} 緯度経度やアイコン画像など
 * @param {google.maps.Map} 地図インスタンス
 * @return {google.maps.Marker} インスタンス化されたマーカー
 */
setGoogleMap.prototype.addMarker = function(item, map) { // eslint-disable-line
  return new google.maps.Marker({ // eslint-disable-line
    position: new google.maps.LatLng(+item.latlng[0], +item.latlng[1]), // eslint-disable-line
    icon: `${item.icon}`,
    map,
  });
};

/**
 * すべてのマーカーがおさまる表示範囲を設定
 */
setGoogleMap.prototype.setCenter = function() { // eslint-disable-line
  const _this = this; // eslint-disable-line
  const bounds = new google.maps.LatLngBounds( // eslint-disable-line
    new google.maps.LatLng(+_this.bounds.sw.lat, +_this.bounds.sw.lng), // eslint-disable-line
    new google.maps.LatLng(+_this.bounds.ne.lat, +_this.bounds.ne.lng), // eslint-disable-line
  );
  _this.map.fitBounds(bounds);
};

/**
 * GoogleMapの吹き出し内ソース
 * @param {String} 表示名称 Nagasaki+Airport
 * @param {String} GoogleMap の placeで発行した共有リンク（例 https://goo.gl/maps/jB3DLqewsMsFV1Yq5）
 * @param {String} プロジェクトのアクセシビリティ規約で定められている外部ドメインへ遷移するときの告知テキスト
 * @return {String} 吹き出し内のソース
 */
setGoogleMap.prototype.getInfoContent = function(name, map, noteText, mapAppText) { // eslint-disable-line
  const _this = this; // eslint-disable-line
  const id = map.split('/');
  const result = `<div class="v1-itineraryMap__info">
<strong class="v1-itineraryMap__info-title">${name}</strong>
<p class="v1-itineraryMap__info-map">
  <a class="v1-itineraryMap__info-link" href="${map}" target="_blank">
    <span class="v1-itineraryMap__info-linkText">
      ${mapAppText}
    </span>
    <svg class="v1-itineraryMap__info-siteLinkBlank" viewBox="0 0 24 24" role="note" aria-labelledby="label__recommendationItineraryMap__${
      id[id.length - 1]
    }" focusable="false">
      <desc id="label__recommendationItineraryMap__${id[id.length - 1]}">${noteText}</desc>
      <use xlink:href="/japan-travel-planner/common/svg/sprite.svg#blank"></use>
    </svg>
  </a>
</p>
</div>`;
  return result;
};

// EXPORT
export default option => new setGoogleMap(option); // eslint-disable-line
